import { render } from "./PresensiView.vue?vue&type=template&id=4b4d6e67"
import script from "./PresensiView.vue?vue&type=script&lang=js"
export * from "./PresensiView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__